import type { TablePaginationConfig } from 'antd';

import i18n from 'segments/i18n';


export const defaultPaginationConfig: TablePaginationConfig = {
  size: 'default',
  showSizeChanger: true,
  position: ['bottomCenter'],
  pageSizeOptions: [5, 10, 30, 50],
};

export const getMonthList = () => [
  i18n.t('dates.january', 'Январь'),
  i18n.t('dates.february', 'Февраль'),
  i18n.t('dates.march', 'Март'),
  i18n.t('dates.april', 'Апрель'),
  i18n.t('dates.may', 'Май'),
  i18n.t('dates.june', 'Июнь'),
  i18n.t('dates.july', 'Июль'),
  i18n.t('dates.august', 'Август'),
  i18n.t('dates.september', 'Сентябрь'),
  i18n.t('dates.october', 'Октябрь'),
  i18n.t('dates.november', 'Ноябрь'),
  i18n.t('dates.december', 'Декабрь')
];

export enum WeekEnumEng {
  sunday,
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
}

export enum WeekEnumRu {
  Воскресенье,
  Понедельник,
  Вторник,
  Среда,
  Четверг,
  Пятница,
  Суббота,
}

export enum MonthEnumRu {
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
}

export enum MonthEnumEng {
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December
}

